import React, { FC } from "react";

import { Text } from "@epignosis_llc/gnosis";

import {
  emptyStateBody,
  emptyStateContainer,
  emptyStateDescription,
  emptyStateFooter,
  emptyStateIcon,
  emptyStateWrapper,
} from "@components/ReusableComponents/Widgets/components/EmptyState/styles";

import { useApplyTranslations } from "@hooks";

import { EmptyStateProps } from "@components/ReusableComponents/Widgets/components/EmptyState/types";

const EmptyState: FC<EmptyStateProps> = ({ icon, title, info, footer }) => {
  const { t } = useApplyTranslations();
  return (
    <div css={emptyStateWrapper}>
      <div css={emptyStateContainer}>
        {icon && <div css={emptyStateIcon}>{icon}</div>}

        <div css={emptyStateBody}>
          {typeof title === "string" ? (
            <Text fontSize="lg" as="div" weight="700">
              {t(title)}
            </Text>
          ) : (
            title
          )}

          {info && (
            <Text fontSize="sm" as="div" weight="400" css={emptyStateDescription}>
              {t(info)}
            </Text>
          )}
        </div>

        {footer && <div css={emptyStateFooter}>{footer}</div>}
      </div>
    </div>
  );
};

export default EmptyState;
